export default __webpack_public_path__ + "static/media/ic-generate.bdbff727.svg";